export default __webpack_public_path__ + "static/media/04d.d7d4d333.jpg";